import { useEffect } from "react"
import '../../../App.css';
import './Sculc-2022.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Sculc2022 = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="sculc2022-page">
            <div className="sculc2022-header-container">
                <img
                    src="/images/sculc2022/IMG_5105.JPG"
                    alt="Header"
                    className="sculc2022-header-image"
                />  
                <h1 className="sculc2022-title">Photos</h1>
            </div>
            <div className="sculc2022-navbar">
                <div className="sculc2022-navbar-container">
                    <a href="/sculc-2022" className="sculc2022-links">Home</a>
                    <a href="/sculc-2022-program" className="sculc2022-links">Programs</a>
                    <a href="/sculc-2022-presentation" className="sculc2022-links">Presentations</a>
                    <a href="/sculc-2022-photo" className="sculc2022-links">Photos</a>
                </div>
            </div>
            <div className="sculc2022-container">
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds">
                        <img src="/images/sculc2022/IMG_5121_crop.JPG" alt="" width="100%" data-aos="fade-up" data-aos-once="true" data-aos-delay="0"></img>
                        <div style={{height: "3%"} }></div>
                        <img src="/images/sculc2022/IMG_5125_crop.JPG" alt="" width="100%" data-aos="fade-up" data-aos-once="true" data-aos-delay="500"></img>
                    </div>
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_5133.JPG" alt="" width="100%" data-aos="fade-up" data-aos-once="true" data-aos-delay="250"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container" data-aos="fade-up" data-aos-once="true">
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_5131.JPG" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-thirds">
                        <p style={{ fontSize: "1.5em", color: "#4499cc" }}>In-Person Presenters: </p>
                        <br></br>
                        <p>Front: Lydia Lee (Yale University), Crystal Gong (UCSB), Emma Churchill (UCLA)</p>
                        <br></br>
                        <p>Back: Carson Collins & Penelope Hurtado Stuart  (University of Arizona), Trevor Htoon (UCLA), Jean-Max Fawzi (UCLA)</p>
                    </div>
                </div>
                <div className="sculc2022-table-container" data-aos="fade-up" data-aos-once="true">
                    <div className="sculc2022-image-two-thirds">
                        <p style={{ fontSize: "2em", color: "#4499cc" }} >Keynote Speaker: Carson Schütze</p>
                        <br></br>
                        <p>University of California, Los Angeles & Massachusetts Institute of Technology</p>
                        <br></br>
                        <p>The many ways in which crowd-sourced judgments can be misleading</p>
                    </div>
                    <div className="sculc2022-image-thirds">
                        <img src="/images/sculc2022/IMG_5093.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds">
                        <img src="/images/sculc2022/IMG_5103.JPG" alt="" width="100%"></img>
                        <div style={{ height: "3%" }}></div>
                        <img src="/images/sculc2022/IMG_5096.JPG" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_7834.jpeg" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container" style={{marginTop: "2em", marginBottom: "2em"} }>
                    <p>(Top Left) Trevor Htoon 'Japanese Pitch Accent by a Burmese Speaker'</p>
                    <p>(Bottom Left) Lydia Lee 'Investigating Properties of Korean Null Impersonal Pronouns'</p>
                    <p>(Right) Penelope Hurtado Stuart & Carson Collins 'Stop Allophony in Uspanteko'</p>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-half">
                        <img src="/images/sculc2022/IMG_5118.JPG" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-half">
                        <img src="/images/sculc2022/IMG_5107.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-half" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2022/IMG_8103.jpg" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em" , lineHeight: "3"}}>Jean-Max Fawzi</p>
                        <p>'The Etymology of ñimiño'</p>
                    </div>
                    <div className="sculc2022-image-half" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2022/IMG_2683.jpg" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em", lineHeight: "3" }}>Emma Churchill</p>
                        <p>'Child Acquisition of Dental Stop Consonants in Spanish'</p>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-half">
                        <img src="/images/sculc2022/IMG_5105.JPG" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-half">
                        <img src="/images/sculc2022/IMG_5117.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2022/IMG_8110.jpg" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em", lineHeight: "3" }}>Crystal Gong</p>
                        <p>'“My kokoro is male!”: Bodily resources for constructing gender and sex in IS: otoko demo nai onna demo nai sei'</p>
                    </div>
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_5112.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2022/IMG_8112.jpg" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em", lineHeight: "3" }}>Yizhuo Zhang</p>
                        <p>'A Conversation-analytic Approach Towards the Scaffolded Meaning Negotiation of Chinese EFL learners across Proficiency Levels'</p>
                    </div>
                    <div className="sculc2022-image-two-thirds" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2022/zoom.png" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em"}}>SCULC 2022 offered a virtual option for those that could not attend in person due to COVID-19 related circumstances</p>
                        <p>(Right) In-Person Presenter Jean-Max Fawzi</p>
                        <p>(Bottom Right)  Asheeya Fatimah Bantuas</p>
                    </div>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds">
                        <img src="/images/sculc2022/IMG_8759.jpg" alt="" width="100%"></img>
                        <div style={{ height: "3%" }}></div>
                        <img src="/images/sculc2022/IMG_8122.jpg" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_8757.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2022-table-container" style={{ textAlign: "left", marginTop: "2em", marginBottom: "2em"}}>
                    <p>(Right) SCULC 2022 incorporated virtual posters via Smartboards for its poster session; featuring Trevor Htoon & conference attendees</p>
                    <p>(Top Left) BLing Treasurer Paul Li & President / SCULC 2022 Chair Jennifer Miyaki</p>
                    <p>(Bottom Left) BLing President Jennifer Miyaki, Campus Representative Isabelle Altman, & Vice President Serena Gutridge</p>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-thirds">
                        <img src="/images/sculc2022/IMG_5124.JPG" alt="" width="100%"></img>
                        <div style={{ height: "3%" }}></div>
                        <img src="/images/sculc2022/IMG_8756.jpg" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-two-thirds">
                        <img src="/images/sculc2022/IMG_5106.JPG" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc-table-container">
                    <p style={{ color: "#4499cc", fontSize: "1.8em",  textAlign: "center", margin: "2em"}}>SCULC 2022 once again thanks all of its presenters, volunteers, and attendees for their participation and contribution to this conference.</p>
                </div>
                <div className="sculc2022-table-container">
                    <div className="sculc2022-image-half">
                        <img src="/images/sculc2022/photographer.jfif" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2022-image-half">
                        <p style={{ color: "#4499cc", fontSize: "2.3em"}}>Eden Yu (photographer)</p>
                        <p>SCULC 2022 would like to thank its photographer, Eden Yu.</p>
                        <p>Eden Yu is a linguistics-computer science major at UCLA.</p>
                    </div>
                </div>

            </div>
            
            <div style={{height: "5vh"} }></div>
                
        </div>
    );
};

export default Sculc2022;
